export const TOGGLE_UI = 'TOGGLE_UI';
export const RESET_UI = 'RESET_UI';
